export default __webpack_public_path__ + "static/media/game_design.71ce3c14.jpg";